import { render, staticRenderFns } from "./MagazineTabDraggable.vue?vue&type=template&id=9bee2320&"
import script from "./MagazineTabDraggable.vue?vue&type=script&lang=js&"
export * from "./MagazineTabDraggable.vue?vue&type=script&lang=js&"
import style0 from "./MagazineTabDraggable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports